import React from 'react';
import ProfileUpdate from './ProfileUpdate';
import PageLayout from '../../layout/containers/PageLayout';

const ProfileUpdatePage: React.FC = () => {
  return (
    <PageLayout>
      <ProfileUpdate />
    </PageLayout>
  );
};

export default ProfileUpdatePage;
